import { isMobileDevice, recursiveAndCheck, filterStoreMapData, getTernaryValue } from 'common/utilities/utils';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MapComponent from '../Presentation/MapComponent';
import ImageComponent from 'atoms/Image';
import SearchStoreCardDynamic from '../Presentation/SearchStoreCardDynamic';
import { searchStoreConfig } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useSelector } from 'react-redux';
const { UseLocationIcon } = IMAGE_PATH;

const MapContainer = props => {
  const {
    eligibleStores,
    loggedIn,
    selectedStoreId,
    selectedCoords,
    passAddress,
    configSearchKey,
    useCurrentLocation,
    showLocationConfirmModal,
    findAKFC,
    favouriteStores,
  } = props;
  const { componentOptions } = useSelector(state => state?.tenantReducer);
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  // Getting the config to change the page behavior as per selected disposition
  const {
    shouldShowStoresLocation,
    shouldShowStoreCardsMap,
    shouldShowMarkerWithText,
    shouldIgnoreStoreList,
    storeOpenBtnText,
  } = {
    ...searchStoreConfig?.[configSearchKey],
    ...dispositionConfig?.[configSearchKey],
  };

  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [selectedStore, setSelectedStore] = useState({ storeDetails: {}, storeIndex: 0 });
  const [latLongValueList, setLatLongValueList] = useState([]);
  const [showStoreCard, setShowStoreCard] = useState(true);
  const [storeCardHeight, setStoreCardHeight] = useState(200);
  const [mapHeight, setMapHeight] = useState(400);

  const setStoresData = currentStoreId => {
    let storeIndex = eligibleStores?.findIndex(store => store?.id === currentStoreId);
    storeIndex = storeIndex === -1 ? 0 : storeIndex;
    setSelectedStore({ storeDetails: eligibleStores?.[storeIndex], storeIndex });
    setShowStoreCard(Boolean(eligibleStores?.length));
  };

  const onPositionChangeHandler = type => {
    if (type === 0) {
      setStoresData(eligibleStores?.[selectedStore?.storeIndex - 1]?.id);
    } else if (type === 1) {
      setStoresData(eligibleStores?.[selectedStore?.storeIndex + 1]?.id);
    }
  };

  const setStoreMarker = latLongObj => {
    const filteredStore = filterStoreMapData(eligibleStores, latLongObj);
    filteredStore && setStoresData(filteredStore?.id);
  };

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
    const searchStoreContent = document.getElementById('search-store-global-content')?.clientHeight;
    const modalBodyHeight = document.querySelector('.modal-body')?.clientHeight;
    let calculatedMapHeight = (modalBodyHeight - searchStoreContent) * 0.9;
    if (isMobileView) {
      const mapStoreCardHeight = document.getElementById(`store-card-${selectedStore?.storeDetails?.id}`)?.clientHeight;
      calculatedMapHeight = modalBodyHeight - searchStoreContent - mapStoreCardHeight;
    }
    setMapHeight(calculatedMapHeight);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  useEffect(() => {
    setStoresData(selectedStoreId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStoreId, favouriteStores]);

  useEffect(() => {
    const latLongValues = eligibleStores?.map(store => {
      return { lat: +store.location.latitude, lng: +store.location.longitude };
    });
    let coordinates = selectedCoords?.lat ? selectedCoords : { lat: -35.2809, lng: 149.13 };
    latLongValues?.length ? setLatLongValueList(latLongValues) : setLatLongValueList(coordinates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favouriteStores, selectedStoreId]);

  useEffect(() => {
    const mapStoreCardHeight = document.getElementById(`store-card-${selectedStore?.storeDetails?.id}`)?.clientHeight;
    if (mapStoreCardHeight) {
      setStoreCardHeight(mapStoreCardHeight);
    }
    // eslint-disable-next-line
  }, [selectedStore?.storeDetails?.id]);

  useEffect(() => {
    windowResized();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showMapViewCard = recursiveAndCheck(showStoreCard, shouldShowStoreCardsMap);
  return (
    <div className={`takeawayDineInMap delivery-map global-map`}>
      <div
        className={
          findAKFC
            ? `${getTernaryValue(showMapViewCard, 'store-dynamic-mapcard-container', 'store-no-mapcard-container')}`
            : 'selectkfc-mapcard-container'
        }
      >
        {showMapViewCard && (
          <SearchStoreCardDynamic
            store={selectedStore?.storeDetails}
            isMapView={true}
            loggedIn={loggedIn}
            centerIndex={selectedStore?.storeIndex}
            storeLength={eligibleStores?.length}
            findAKFC={findAKFC}
            storeOpenBtnText={storeOpenBtnText}
          />
        )}
      </div>
      {
        <div
          className={
            findAKFC
              ? `${getTernaryValue(showMapViewCard, 'mapcard-container', 'no-mapcard-container')}`
              : 'selectkfc-map-container'
          }
        >
          <MapComponent
            latLongValue={latLongValueList}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            passAddress={passAddress}
            isVisible={shouldShowStoresLocation}
            isMobile={isMobile}
            centerIndex={selectedStore?.storeIndex}
            onPositionChangeHandler={onPositionChangeHandler}
            setShowCard={setShowStoreCard}
            setStoreMarker={setStoreMarker}
            storeCardHeight={storeCardHeight}
            isMarkerVisible={shouldIgnoreStoreList || Boolean(eligibleStores?.length)}
            shouldShowMarkerWithText={shouldShowMarkerWithText}
            locationAlertProp={shouldShowMarkerWithText}
            style={{ height: `${mapHeight}px` }}
            defaultZoom={12}
          />
        </div>
      }
      <div
        className={`use-location-icon ${showLocationConfirmModal ? 'disable-location-icon' : ''}`}
        style={{ bottom: storeCardHeight + 15 + 'px' }}
      >
        <ImageComponent
          srcFile={UseLocationIcon}
          alt={''}
          onClick={useCurrentLocation}
          data-testid='use-location-icon'
        />
      </div>
    </div>
  );
};

MapContainer.propTypes = {
  eligibleStores: PropTypes.array,
  loggedIn: PropTypes.bool,
  selectedStoreId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedCoords: PropTypes.object,
  passAddress: PropTypes.func,
  configSearchKey: PropTypes.string,
  useCurrentLocation: PropTypes.func,
};

/* istanbul ignore next */
MapContainer.defaultProps = {
  eligibleStores: [],
  loggedIn: false,
  selectedStoreId: '',
  selectedCoords: {},
  passAddress: null,
  configSearchKey: 'FORM',
  useCurrentLocation: null,
};

export default MapContainer;
